export default "__VITE_ASSET__67g1XInQ__"